import PropTypes from 'prop-types';
import { CommonIDPropType } from './common';
import MaskedIdentityPropType from './MaskedIdentity';

const PaymentCodePropType = PropTypes.shape({
  id: CommonIDPropType,
  code: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool,
  expiryDate: PropTypes.string,
  lastUsed: PropTypes.string,
  sharedCount: PropTypes.number,
  identities: PropTypes.arrayOf(MaskedIdentityPropType)
});
export default PaymentCodePropType;
